import { render } from "./DVCommand.vue?vue&type=template&id=340cf2ca"
import script from "./DVCommand.vue?vue&type=script&lang=js"
export * from "./DVCommand.vue?vue&type=script&lang=js"

import exportComponent from "C:\\ami-website\\www-restore\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__